/**
 * PlatbyModal — the payments of one reservation in their own dialog (P6-e2), opened by "Platby" on a list row: the way to the money of a
 * reservation whose form is closed to edits (a returned or cancelled one) or opened by a member who cannot change it. The content is the
 * same `PlatbyPanel` the reservation form shows.
 */

import { useState } from 'react';
import { Button } from '@/components/Button';
import { Modal, DialogCrown } from '@/components/Modal';
import type { Rezervace } from './api';
import { PlatbyPanel } from './PlatbyPanel';
import { formatTermin } from './rezervace-helpers';

interface PlatbyModalProps {
  rezervace: Rezervace;
  /** What the dialog titles the car with (plate or VIN). */
  title: string;
  canWrite: boolean;
  canAdmin: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PlatbyModal({ rezervace, title, canWrite, canAdmin, open, onOpenChange }: PlatbyModalProps) {
  // a payment in flight keeps the dialog open: its toast hangs on an observer a close would unmount
  const [busy, setBusy] = useState(false);
  const guarded = (next: boolean) => {
    if (!next && busy) return;
    onOpenChange(next);
  };
  return (
    <Modal open={open} onOpenChange={guarded} maxWidth={640}>
      <DialogCrown
        eyebrow="Platby"
        eyebrowMeta={<span>№ {rezervace.id}</span>}
        title={
          <>
            Platby <em>{title}</em>
          </>
        }
        sub={`${rezervace.zakaznik_nazev ? `${rezervace.zakaznik_nazev} · ` : ''}${formatTermin(rezervace.od, rezervace.do)}`}
      />
      <Modal.Body className="px-8 py-5">
        <PlatbyPanel rezervace={rezervace} canWrite={canWrite} canAdmin={canAdmin} onBusy={setBusy} />
      </Modal.Body>
      <Modal.Foot
        actions={
          <Button variant="secondary" disabled={busy} onClick={() => guarded(false)}>
            Zavřít
          </Button>
        }
      />
    </Modal>
  );
}
